import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import * as fromPowerlaneAnalytics from './+state/powerlane-analytics.reducer';
import { PowerlaneAnalyticsEffects } from './+state/powerlane-analytics.effects';
import { PowerlaneAnalyticsFacade } from './+state/powerlane-analytics.facade';
import { PowerLaneEntityEffects } from './+state/powerlane-entity.effects';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature(fromPowerlaneAnalytics.POWERLANEANALYTICS_FEATURE_KEY, fromPowerlaneAnalytics.reducer),
    EffectsModule.forFeature([PowerlaneAnalyticsEffects, PowerLaneEntityEffects]),
  ],
  providers: [PowerlaneAnalyticsFacade],
})
export class PowerLaneAnalyticsModule {}
